import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import BottomNav from './BottomNav'
import Header from './Header'
import { ResumeWorkoutModal } from '@/components/workout/ResumeWorkoutModal'
import { useWorkoutStore } from '@/stores/workoutStore'

export default function Layout() {
  const location = useLocation()
  const { checkForSavedWorkout, savedWorkoutInfo } = useWorkoutStore()
  const [showResumeModal, setShowResumeModal] = useState(false)

  // Check for saved workout when NOT on workout page
  useEffect(() => {
    const isWorkoutPage = location.pathname.startsWith('/workout')

    // Don't show modal on workout page - user is actively working out
    if (isWorkoutPage) {
      setShowResumeModal(false)
      return
    }

    // Check for saved workout in IndexedDB
    checkForSavedWorkout().then((info) => {
      if (info) {
        setShowResumeModal(true)
      }
    })
  }, [location.pathname, checkForSavedWorkout])

  // Also check when visibility changes (user returns to app)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const isWorkoutPage = location.pathname.startsWith('/workout')
        if (!isWorkoutPage) {
          checkForSavedWorkout().then((info) => {
            if (info) {
              setShowResumeModal(true)
            }
          })
        }
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange)
  }, [location.pathname, checkForSavedWorkout])

  return (
    <div className="flex flex-col min-h-screen bg-background">
      {/* Header */}
      <Header />

      {/* Main content area */}
      <main className="flex-1 overflow-y-auto pb-20">
        <Outlet />
      </main>

      {/* Bottom navigation */}
      <BottomNav />

      {/* Resume Workout Modal */}
      {showResumeModal && savedWorkoutInfo && (
        <ResumeWorkoutModal onClose={() => setShowResumeModal(false)} />
      )}
    </div>
  )
}
